import { useReducer, useState } from 'react'
import PinSettings from './Settings'
import { pinReducer } from './util'
import { Pin as PinType } from './types'
import { isDev, isLocal } from '@/config'
import { classNames } from '@/util/tailwindHelpers'

interface PinProps extends PinType {
  className?: string
}

const Pin = ({ className, ...pin }: PinProps) => {
  const shouldAllowSettings = isDev || isLocal
  const { element, anchor, position } = pin

  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const [state, dispatch] = useReducer(pinReducer, {
    anchorX: anchor.x,
    anchorY: anchor.y,
    positionX: position.x,
    positionY: position.y
  })

  const handeClick = () => {
    if (shouldAllowSettings) {
      setIsSettingsOpen(!isSettingsOpen)
    }
    return undefined
  }

  return (
    <>
      {shouldAllowSettings && (
        <PinSettings
          isOpen={isSettingsOpen}
          onClose={() => setIsSettingsOpen(false)}
          settings={state}
          onChange={dispatch}
        />
      )}

      <div
        onClick={handeClick}
        className={classNames('absolute w-max', className)}
        style={{
          left: `${state.positionX}%`,
          top: `${state.positionY}%`
        }}
      >
        <div
          style={{
            transform: `translate(-${state.anchorX}%, -${state.anchorY}%)`
          }}
        >
          {element}
        </div>
      </div>
    </>
  )
}

export default Pin
